import { Box, Button, makeStyles, Typography } from '@material-ui/core';
import { WbCardContent } from '../WbCard';
import { WbNoData } from '../WbNoData';
import { WbChip } from '../WbTextField';
import { useMultiSelectionPickerContext } from './MultiSelectionPickerContext';
import { GenericElement } from './types';

const useStyles = makeStyles(
  theme => ({
    cardContent: {
      height: '100%',
      padding: theme.spacing(0),
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(1),
    },
    selected: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(0.5),
      overflow: 'auto',
      height: '100%',
    },
  }),
  { name: 'SelectedEntities' },
);

interface SelectedEntitiesProps {
  values: GenericElement[];
  setValues: (values: GenericElement[]) => void;
}

const Content = ({ values, setValues }: SelectedEntitiesProps) => {
  const classes = useStyles();
  const { disableAll } = useMultiSelectionPickerContext();
  const handleDelete = (indexToDelete: number) => () => {
    setValues(values.filter((_, index) => index !== indexToDelete));
  };

  const adaptLabel = (option: GenericElement) => {
    const labelKind = option?.kind;
    return `${labelKind ? `${labelKind}:` : ''} ${
      option?.displayName ?? option.name
    }`;
  };

  if (disableAll) {
    return (
      disableAll && (
        <WbChip key="all" label="*All*" style={{ width: 'fit-content' }} />
      )
    );
  }

  return !values?.length ? (
    <WbNoData
      fillContainer
      header="You haven't made any selection yet."
      text="Select what you need from the list on the left."
    />
  ) : (
    <Box className={classes.selected}>
      {values?.map((e: GenericElement, index: number) => (
        <WbChip
          key={e.id}
          label={adaptLabel(e)}
          onDelete={handleDelete(index)}
          style={{ width: 'fit-content' }}
        />
      ))}
    </Box>
  );
};

export const SelectedValues = (props: SelectedEntitiesProps) => {
  const classes = useStyles();
  const { values, setValues } = props;

  return (
    <WbCardContent className={classes.cardContent}>
      <Box className={classes.root}>
        <Typography variant="body1"> Your selection</Typography>
        <Button
          variant="outlined"
          size="small"
          color="primary"
          disabled={!values?.length}
          onClick={() => setValues([])}
        >
          Clear all
        </Button>
      </Box>

      <Content {...props} />
    </WbCardContent>
  );
};
